import { mario } from './../characters/Mario';
import { vanessaDad } from './../characters/VanessaDad';
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { images } from "./images";
import { vanessaMom } from '../characters/VanessaMom';
import { cashier } from '../characters/Cashier';
import Question from '../../src/shell/Questions';
import Game from '../../src/shell/Game';
import { V6VanessaShoppingAfter } from './V6';
import { doTransition, doWaitImageByTime } from '../helpers/helpers';

export const V6VanessaShoppingEmilysCar = async (): Promise<any> => {
    doWaitImageByTime(images.v6.MCRoom_1);
    emily.talk(`${mc.name}, I'm heading out.`);
    mc.talk(`Emily! Great timing! I was just about to ask you for your car.`);
    emily.talk(`Already? I thought you'd wait a few days.`);
    mc.talk(`Are you about to use it?`);
    emily.talk(`Nah, just messing with you.`);
    mc.talk(`Ok, great. Does it still have the same code?`);
    emily.talk(`Haha, no, didn't I tell you? I bought a new car.`);
    mc.talk(`You did? When?`);
    emily.talk(`A few months back. Come, I'll show you.`);
    doTransition(images.v6.EmilysCar_0);
    mc.think(`What the...`);
    emily.talk(`Isn't she a beauty?`);
    mc.talk(`Sure... If you are the tooth fairy...`);
    emily.talk(`Come on! It's beautiful! I even waxed it and everything.`);
    ImageClass.setImage(images.v6.EmilysCar_1);
    mc.think(`Holy shit, even the inside is pink.`);
    mc.think(`I bet Vanessa would love this car...`);
    ImageClass.setImage(images.v6.EmilysCar_2);
    emily.talk(`Do you still wanna take it?`);
    mc.talk(`Yes... I told Vanessa I'd pick her up.`);
    emily.talk(`Vanessa? Only both of you?`);
    mc.talk(`Yeah.`);
    emily.talk(`Oh, where are you going?`);
    if (mc.properties.annStatus === "hate") {

        mc.talk(`Back to the clothing store... She wants to see if we can find something for a friend of hers.`);
    } else {
        mc.talk(`Back to the clothing store... She wants to see if we can find something for Ann.`);

    }
    emily.talk(`Oh, ok.`);
    emily.talk(`The code is: 1269.\nHave fun!`);
    emily.talk(`Don't scratch it!`);
    mc.talk(`I won't.\nThanks!`);
    return jump(V6VanessaShoppingPickup, "V6VanessaShoppingPickup");
};

export const V6VanessaShoppingPickup = async (): Promise<any> => {
    doTransition(images.v6.VanessaPickup_0);
    mc.think(`There she is.`);
    vanessa.talk(`BYE FATHER! BYE MOTHER!`, { method: "Shouting" });
    vanessaDad.talk(`BYE DARLING!`, { method: "Shouting" });
    vanessaMom.talk(`DON'T DO DRUGS!`, { method: "Shouting" });
    vanessa.talk(`I WON'T!`, { method: "Shouting" });
    vanessa.talk(`LOVE YOU!`, { method: "Shouting" });
    mc.think(`She continues with her act...`);
    mc.think(`Even if they see me, no way they would suspect something with this car...`);
    ImageClass.setImage(images.v6.VanessaPickup_1);
    mc.think(`She is coming over.`);
    mc.think(`She said she usually get out of her house with some ugly dress on top of her clothes...`);
    ImageClass.setImage(images.v6.VanessaPickup_3);
    vanessa.talk(`O-M-G! I love this car!`);
    ImageClass.setImage(images.v6.VanessaPickup_2);
    mc.talk(`I had a feeling you'd like it.`);
    ImageClass.setImage(images.v6.VanessaPickup_3);
    vanessa.talk(`How can't I? Great color!`);
    ImageClass.setImage(images.v6.VanessaPickup_2);
    mc.talk(`...`);
    mc.talk(`Are we ready to go?`);
    vanessa.talk(`Yeah step on it. Before my idiot parents see me.`);


    return jump(V6VanessaShopping, "V6VanessaShopping");
};


export const V6VanessaShopping = async (): Promise<any> => {
    doWaitImageByTime(images.v6.VanessaShopping_0);

    mc.talk(`Here we are.`);
    vanessa.talk(`That was quick.`);
    mc.talk(`I told you it's close.`);
    vanessa.talk(`Still. I ain't walking with my heels on.`);

    vanessa.talk(`Weird... I don't know this place.`);
    mc.talk(`Emily said it's new, they just opened.`);
    vanessa.talk(`That's explain the lack of customers.`);
    vanessa.talk(`Park the car, let's take a look!`);
    doWaitImageByTime(images.v6.VanessaShopping_2);
    vanessa.talk(`Nice... Nice... I like what I see.`);
    ImageClass.setImage(images.v6.VanessaShopping_3);
    mc.talk(`Me too.`);
    vanessa.talk(`Huh?`);
    ImageClass.setImage(images.v6.VanessaShopping_1);
    vanessa.talk(`Were you looking at my ass?`);
    mc.talk(`No.`);
    vanessa.talk(`Liar.`);
    vanessa.talk(`I'm gonna ask the saleswoman where they store their sexiest outfits!`);
    mc.think(`Oh shit.... Here we go again.`);
    return jump(V6VanessaShoppingSalesWoman, "V6VanessaShoppingSalesWoman");
};

export const V6VanessaShoppingSalesWoman = async (): Promise<any> => {
    doWaitImageByTime(images.v6.VanessaShopping_4);
    vanessa.talk(`Hey, I need to know where you store your sexiest outfits.`);
    cashier.think(`*Click click click click*`);
    vanessa.talk(`...`);
    ImageClass.setImage(images.v6.VanessaShopping_5);
    cashier.talk(`Hey! That's mine!`);
    vanessa.talk(`Nope. It's mine until you'd start answering my questions.`);
    ImageClass.setImage(images.v6.VanessaShopping_6);
    cashier.talk(`What do you want?`);
    vanessa.talk(`A service with a smile. But I'll pass on that smile.`);
    cashier.talk(`...`);
    vanessa.talk(`Since I'm in a good mood, I'm gonna repeat it vvveeerrryyy sslllooooowwlllyyy so you'll understand.`);
    vanessa.talk(`Where... Are... Your... Sexiest... Outfits?`);
    cashier.talk(`Everything you see is what we've got.`);
    vanessa.talk(`That's it?`);
    cashier.talk(`The owner just opened, so we are on limited supply.`);
    vanessa.talk(`That sucks.`);
    cashier.talk(`Can I have my phone back now?`);
    ImageClass.setImage(images.v6.VanessaShopping_7);
    vanessa.talk(`Sure.`);
    ImageClass.setImage(images.v6.VanessaShopping_8);
    cashier.talk(`...`);
    mc.think(`So that's how you deal with her...`);


    return jump(V6VanessaShoppingSalesWomanMario, "V6VanessaShoppingSalesWomanMario");
};

export const V6VanessaShoppingSalesWomanMario = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaShopping_9);
    mario.talk(`Ah-am!`);
    mc.think(`Hey... That's Mario, he wasn't here when we got in, he must've also came back.`);
    ImageClass.setImage(images.v6.VanessaShopping_10);
    mario.talk(`Yo! ${mc.name}?`);
    mario.talk(`Still here? I thought I saw you leaving.`);
    mc.talk(`I did... But I just came back.`);
    if (Question.globalAnswers.v1EnableNTR) {
        mario.talk(`You did? Where is your hot ${emily.properties.relation}? Haha.`);
        mc.talk(`She's at home, I came back with Vanessa, the girl standing in front of you.`);

    } else {

    }
    mc.talk(`What are you doing here?`);
    mario.talk(`My "AMAZING" girlfriend decided she doesn't like the outfit I bought for her.`);
    ImageClass.setImage(images.v6.VanessaShopping_11);
    mario.talk(`So she sent me to return it.`);
    mc.talk(`Why? What's wrong with?`);
    if (Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingLingerieAmber_Question_Excuse`)) {

        mc.think(`It seems pretty good to me...`);
    }
    mario.talk(`Beats me... She suddenly decided she doesn't like it.`);
    ImageClass.setImage(images.v6.VanessaShopping_12);
    vanessa.talk(`Who doesn't like what?`);
    ImageClass.setImage(images.v6.VanessaShopping_13);
    vanessa.talk(`What's that?`);
    mc.think(`Vanessa and her manners...`);
    mario.talk(`Something I'm gonna return.`);
    vanessa.talk(`Why?`);
    mario.talk(`My girl doesn't like it.`);
    vanessa.talk(`Can I have a look?`);
    mario.talk(`Go ahead.`);
    ImageClass.setImage(images.v6.VanessaShopping_14);
    vanessa.talk(`Nice!`);
    ImageClass.setImage(images.v6.VanessaShopping_15);
    vanessa.talk(`You must be one lucky guy!`);
    mario.talk(`Only when we don't go shopping together. That shit costs 80 bucks.`);
    ImageClass.setImage(images.v6.VanessaShopping_16);
    vanessa.talk(`Are you serious?`);
    vanessa.talk(`It's just a fishing net.`);
    mario.talk(`I know, but you can try and argue with my girl, I gave up along time ago.`);
    vanessa.talk(`Not every girl would wear this for her man. You should appreciate it.`);
    mario.talk(`Ah... I guess...`);
    return jump(V6VanessaShoppingSalesWomanMario_2, "V6VanessaShoppingSalesWomanMario_2");
};

export const V6VanessaShoppingSalesWomanMario_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaShopping_17);
    if (mc.properties.annStatus === "hate") {

        vanessa.talk(`I bet this would look good on my friend, don't you think?`);
        mc.talk(`I have no idea, I don't know what she looks like.`);
        vanessa.talk(`Yeah... Right.`);
    } else {


        vanessa.talk(`I bet this would look good on Ann, don't you think?`);
        if (Game.seenScenarios.includes(`V5AnnMovie`)) {
            mc.talk(`I don't know. It's hard to imagine it on her.`);
        } else {
            mc.talk(`No way she's gonna wear it.`);
        }
        vanessa.talk(`Trust me! It's perfect!`);
        mc.talk(`If you say so.`);
    }

    ImageClass.setImage(images.v6.VanessaShopping_16);
    vanessa.talk(`Can you loan it to us for a few days?`);
    mario.talk(`Why not, you can even take it.`);
    vanessa.talk(`How generous of you!`);
    mario.talk(`For 80 dollars.`);
    mario.talk(`I work hard for my cash, I can't just throw it away.`);
    vanessa.talk(`Aren't you friends with ${mc.name}?`);
    mario.talk(`I only met him a few hours ago.`);
    vanessa.talk(`Oh.`);
    ImageClass.setImage(images.v6.VanessaShopping_18);
    vanessa.talk(`Pretty please...`);
    vanessa.talk(`I swear! We'll just borrow it for a few days and give it back to you. Easy peasy!`);
    mario.talk(`Ah... I don't know...`);
    vanessa.talk(`A big guy like you shouldn't be scared of not getting his debt paid... I'm sure you can handle anything!`);
    ImageClass.setImage(images.v6.VanessaShopping_19);
    mario.talk(`Haha, yes I always take care of my problems when they pop up.`);
    vanessa.talk(`Because you are a real man! Any girl would be lucky to have you!`);
    mario.talk(`Ha...Ha...`);
    vanessa.talk(`I'll give you ${mc.name}'s number! If we won't return it in time just give him a call!\nI'm sure you could work something out.`);
    ImageClass.setImage(images.v6.VanessaShopping_20);
    mario.talk(`Sure bro, you can have it.`);
    mc.talk(`Thanks dude.`);
    mario.talk(`For a few days.`);
    mc.talk(`Of course.`);
    ImageClass.setImage(images.v6.VanessaShopping_19);
    mario.talk(`Bye! I'll cya around!`);
    vanessa.talk(`Bye handsome.`);
    mc.think(`Holy shit, I better not lose it.`);
    return jump(V6VanessaShopping_Question, "V6VanessaShopping_Question");
};

export const V6VanessaShopping_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaShopping_25, { transition: true });
    await vanessa.setQuestion(new Question({ text: `Ok, so we are all set!`, options: { think: false }, key: `v6VanessaClothingAskedHerToTryOnOutfit` })
        .option({ title: `Tell her to try it on`, key: true })
        .option({ title: `Just leave`, key: false }));


    if (Question.globalAnswers.v6VanessaClothingAskedHerToTryOnOutfit) {
        if (mc.properties.joeStatus === "enemy") {

            return jump(V6VanessaShopping_Question_Refused, "V6VanessaShopping_Question_Refused");
        }
        return jump(V6VanessaShopping_Question_TryOn, "V6VanessaShopping_Question_TryOn");
    } else {

        return jump(V6VanessaShopping_Question_Leave, "V6VanessaShopping_Question_Leave");
    }

};

export const V6VanessaShopping_Question_Refused = async (): Promise<any> => {
    if (mc.properties.joeStatus === "enemy") {

        ImageClass.setImage(images.v6.VanessaShopping_25);
        mc.talk(`I think you should try it on.`);
        vanessa.talk(`You wish!`);
        mc.talk(`Really? You're not gonna do it?`);
        vanessa.talk(`Nah... I'm good.`);
        mc.think(`I tried...`);
    }

    return jump(V6VanessaShoppingLeaving, "V6VanessaShoppingLeaving");
};



export const V6VanessaShopping_Question_TryOn = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.vanessaRelationship++;
    });
    ImageClass.setImage(images.v6.VanessaShopping_25);
    mc.talk(`Not yet.`);
    mc.talk(`I think you should try it on.`);

    vanessa.talk(`You read my mind! I wanted to try it out as well.`);
    vanessa.talk(`Follow me.`);
    ImageClass.setImage(images.v6.VanessaShopping_21);
    vanessa.talk(`Wait here! No peeping!`);
    mc.talk(`Since when do you care about that?`);
    vanessa.talk(`Just wait!`);
    ImageClass.setImage(images.v6.VanessaShopping_22);
    mc.think(`She's definitely gonna expand the outfit in the boobs area...`);
    ImageClass.setImage(images.v6.VanessaShopping_23, { transition: true });
    vanessa.talk(`So? How do I look?`);
    mc.talk(`...`);
    vanessa.talk(`Cat got your tongue?`);
    mc.talk(`I don't think anyone will complain seeing you in this...`);
    ImageClass.setImage(images.v6.VanessaShopping_24);
    vanessa.talk(`Oh stop it!`);
    if (mc.properties.annStatus === "hate") {
        vanessa.talk(`My friend wouldn't be able to pull it off as much as me.`);
        mc.talk(`I don't know who she is but you must be right...`);
    } else {

        mc.think(`Kinda true...`);
    }
    vanessa.talk(`Ok, you had your fun, time to leave.`);

    return jump(V6VanessaShoppingLeaving, "V6VanessaShoppingLeaving");
};


export const V6VanessaShopping_Question_Leave = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaShopping_25);
    mc.talk(`Yeah. Let's go.`);

    return jump(V6VanessaShoppingLeaving, "V6VanessaShoppingLeaving");
};

export const V6VanessaShoppingLeaving = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaShopping_28, { transition: true, duration: 0.6 });
    vanessa.talk(`It was fun. Now I can see why Emily wants to go out with you so much.`);

    if (mc.properties.annStatus === "hate") {
        mc.talk(`Maybe... But why didn't you go with the friend of yours? I don't even know her name.`);
        ImageClass.setImage(images.v6.VanessaShopping_26);
        vanessa.talk(`Since we are done I can come clean.`);
        vanessa.talk(`There is no friend. I meant Ann all along.`);
        mc.talk(`What? Are you serious?`);
        vanessa.talk(`I knew you wouldn't agreed to come with me if I said I wanna buy something for Ann.`);
        vanessa.talk(`You know... Since you are not together and all of that.`);
        mc.talk(`...`);
        mc.talk(`Yeah... I wouldn't have joined you.`);
        ImageClass.setImage(images.v6.VanessaShopping_28);
        vanessa.talk(`You see! That's why I lied.`);
        ImageClass.setImage(images.v6.VanessaShopping_29);
        if (mc.properties.joeStatus === "enemy") {

            vanessa.talk(`Now, take me home!`);
        } else {

            vanessa.talk(`Now, take me home! I made plans with Joe.`);
        }
        return jump(V6VanessaShoppingAfter, "V6VanessaShoppingAfter");
    }
    if (Game.seenScenarios.includes(`V6EmilyCoffeeCustomer`) && !Game.seenScenarios.includes(`V6VanessaMCCustomerSMSConv`)) {

        vanessa.talk(`Now, take me home! I made plans with Joe.`);
        ImageClass.setImage(images.v6.VanessaShopping_26);
        mc.talk(`Wait, there is still one more thing.`);
        mc.talk(`Funny story, but I came across that dude from your work place... You know, the one that got you fired.`);
        ImageClass.setImage(images.v6.VanessaShopping_27);
        vanessa.talk(`And you are telling me this just now?`);
        mc.talk(`You didn't give me a chance to speak! You were like: "pick me up, let's go there, I'm gonna do that".`);
        ImageClass.setImage(images.v6.VanessaShopping_26);
        vanessa.talk(`Ok, fine, where did you see him? What did he say? Details!`);
        mc.talk(`Emily wanted to grab a coffee so we went to the coffee shop and I saw him sitting inside.`);
        ImageClass.setImage(images.v6.VanessaShopping_27);
        vanessa.talk(`That bastard! He said he wasn't gonna return there.\nLiar!`);

        ImageClass.setImage(images.v6.VanessaShopping_26);
        vanessa.talk(`Did you talk to him? What does he want?`);
        mc.talk(`I'm not exactly sure.`);
        mc.talk(`He said that he is willing to meet you in order to set things straight.`);
        if (Game.seenScenarios.includes(`LineVanessaRude`) || Game.seenScenarios.includes(`BJVanessaRude`)) {


        } else {

        }
        if (mc.properties.v3RudeToTheCustomer) {
            ImageClass.setImage(images.v6.VanessaShopping_27);
            vanessa.talk(`Is he being serious? It's not like I robbed a bank. I just told him to fuck off. Like what the fuck?`);
        } else if (mc.properties.v3RudeToTheCustomer === false) {

            ImageClass.setImage(images.v6.VanessaShopping_27);
            vanessa.talk(`Is he being serious? It's not even my fault!`);
        }


        mc.talk(`He said that you can agree to it or find another job.`);
        vanessa.talk(`So are you gonna let me deal with it by myself now?`);
        mc.talk(`No.\nHe said that I can be there with you.`);

        ImageClass.setImage(images.v6.VanessaShopping_28);
        vanessa.talk(`Oh! That's great!`);
        mc.talk(`I guess...`);
        ImageClass.setImage(images.v6.VanessaShopping_26);
        vanessa.talk(`By the way, how did he act?\nDid he seem pissed or anything?`);
        mc.talk(`Not really. He had this smirk on his face like he knew I would come to talk to him.`);
        vanessa.talk(`Bastard.`);
        vanessa.talk(`Anyway, how are you gonna contact him to tell him I'm willing to meet with him?`);
        mc.talk(`He gave me his number.`);
        vanessa.talk(`And where does he want to meet?`);
        ImageClass.setImage(images.v6.VanessaShopping_27);
        vanessa.talk(`Let me guess! A dark creepy alley.`);
        mc.talk(`He said we can choose the location.`);
        ImageClass.setImage(images.v6.VanessaShopping_26);
        vanessa.talk(`Oh.\nWell, that's not so bad.`);
        vanessa.talk(`I'll think of a place to meet and then we'll contact him.\nAgreed?`);
        mc.talk(`Sure.`);
        ImageClass.setImage(images.v6.VanessaShopping_29, { duration: 0.6 });
        vanessa.talk(`Now you can take me home.`);

        return jump(V6VanessaShoppingAfter, "V6VanessaShoppingAfter");
    }

    mc.talk(`Fun? I didn't do anything.`);
    vanessa.talk(`Exactly. You don't complain.`);
    ImageClass.setImage(images.v6.VanessaShopping_29);
    vanessa.talk(`Now, take me home! I made plans with Joe.`);
    return jump(V6VanessaShoppingAfter, "V6VanessaShoppingAfter");
};
